/**
 * Full-page loading overlay on multipart / slow form submits (view-ticket, new-ticket, etc.).
 * Uses bubble phase on document so it runs after form capture listeners (e.g. rich-text sync, priority modal).
 * Skips when defaultPrevented, so the attachment path only shows it on its resubmit.
 */

const DEFAULT_ACTION_SUBSTRINGS = [
  '/reply-ticket',
  '/view-ticket',
  '/create-ticket',
  '/profile',
  '/tomcat-overview',
  '/aws',
  '/ticket-overview',
  '/admin/credits',
  '/admin/groups',
  '/admin/edit-person',
  '/forgot'
];

export function showFormSubmitLoadingOverlay(
    overlaySelector = '[data-form-submit-loading-overlay]'
): void {
    document.querySelector<HTMLElement>(overlaySelector)?.classList.remove('hidden');
}

export function hideFormSubmitLoadingOverlays(
    overlaySelector = '[data-form-submit-loading-overlay]'
): void {
    document.querySelectorAll<HTMLElement>(overlaySelector).forEach((el) => {
        el.classList.add('hidden');
    });
}

export function initFormSubmitOverlay(config?: {
    /** Defaults to [data-form-submit-loading-overlay] from form-submit-loading-overlay.jsp */
    overlaySelector?: string;
    /** If the form action URL contains any of these substrings, the overlay is shown */
    actionIncludes?: string[];
}): void {
    const overlaySelector = config?.overlaySelector ?? '[data-form-submit-loading-overlay]';
    const substrings = config?.actionIncludes ?? DEFAULT_ACTION_SUBSTRINGS;

    window.addEventListener('pagehide', () => {
        hideFormSubmitLoadingOverlays(overlaySelector);
    });
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
            hideFormSubmitLoadingOverlays(overlaySelector);
        }
    });

    const overlay = document.querySelector<HTMLElement>(overlaySelector);
    if (!overlay) {
        return;
    }

    document.addEventListener(
        'submit',
        (e) => {
            if (e.defaultPrevented) {
                return;
            }
            const target = e.target;
            if (!(target instanceof HTMLFormElement)) {
                return;
            }
            const action = target.getAttribute('action') || '';
            if (substrings.some((s) => action.includes(s))) {
                showFormSubmitLoadingOverlay(overlaySelector);
            }
        },
        false
    );
}
